module.exports = __webpack_public_path__ + "/static/images/app-logo.png";